import React from "react";
import { Card } from "react-bootstrap";
import { ContentResponse } from "../../services/api.response.service";
import { baseURL } from "../../services/api.service";

interface CourseContentPracticeProps {
  content: ContentResponse;
}

function CourseContentPractice({ content }: CourseContentPracticeProps) {
  return (
    <Card className="h-100 w-100 overflow-hidden">
      <Card.Body className="p-3">
        <iframe
          src={content.practice_url.replace("/api/v4", String(baseURL))}
          frameBorder="0"
          title={content.title}
          className="w-100"
          style={{ height: "64.2em" }}
        />
      </Card.Body>
    </Card>
  );
}

export default CourseContentPractice;
